import { ModalWindow } from '@/components/ModalWindow/ModalWindow';
import { Box } from '@/components/Box/Box';
import { Typography } from '@/components/Typography/Typography';
import { COLORS } from '@/styles/colors';
import { Button } from '@/components/Button/Button';
import WarningSecondaryIcon from '@/images/WarningSecondaryIcon.svg?react';
import { envConfig } from '@/config/envConfig';
import { NavigationLink } from '@/components/NavigationLink/NavigationLink';
import { CONTACT_MOBILE_PHONE, FORMATTED_CONTACT_MOBILE_PHONE } from '@/const/shared';

type UserLimitReachedModalType = {
  isOpen: boolean;
  onClose: () => void;
};

export const UserLimitReachedModal = ({ isOpen, onClose }: UserLimitReachedModalType) => {
  return (
    <ModalWindow isOpen={isOpen} width='504px'>
      <Box display='flex' flexDirection='column' rowGap='28px' alignItems='center'>
        <Box display='flex' flexDirection='column' rowGap='20px' alignItems='center'>
          <WarningSecondaryIcon />
          <Box display='flex' flexDirection='column' rowGap='12px' alignItems='center'>
            <Typography variant='headline4' color={COLORS.grey[950]} fontWeight='semibold'>
              User limit reached
            </Typography>
            <Typography color={COLORS.grey[950]} textAlign='center'>
              You’ve reached the maximum number of users allowed for your current subscription plan. <br /> To add more
              users, please contact{' '}
              <NavigationLink to={`mailto:${envConfig.SUPPORT_EMAIL_URL}`} size='large'>
                {envConfig.SUPPORT_EMAIL_URL}{' '}
              </NavigationLink>
              or call{' '}
              <NavigationLink to={`tel:${CONTACT_MOBILE_PHONE}`} size='large'>
                {FORMATTED_CONTACT_MOBILE_PHONE}{' '}
              </NavigationLink>
              to upgrade your plan or block existing users.
            </Typography>
          </Box>
        </Box>
        <Button onClick={onClose}>Back</Button>
      </Box>
    </ModalWindow>
  );
};
